import { ManufacturerModelRow, ManufacturerModelTechSpecRow } from "./types";

export const MOCK_MANUFACTURER_MODELS: ManufacturerModelRow[] = [
  {
    id: "1",
    manufacturerKey: "MANUFACTURERS.DATA.MERCEDES",
    model: "ACTROS 25xxL 26T 16",
    year: 2016,
    chassisWidth: 760,
    openingBase: "U140",
    trackWidth: 2550,
    frontOverhang: 1440,
    licensedWeight: 26000,
    drive: "6x2",
    wheelbase: "U140",
    chassisWeight: null,
    frontAxleDistance: 0,
    sideLighting: true,
    sideGuard: true,
    mudguard: true,
    extendableChassis: true,
  },
];

export const MOCK_TECH_SPECS: ManufacturerModelTechSpecRow[] = [
  {
    id: "1",
    driverCabinType: "בודד",
    tire: null,
    classType: null,
    weight: null,
    axlesMeasure: 5480,
    lowerLimit: 800,
    upperLimit: 990,
    frontLoad: null,
    rearAxlesMeasure: null,
    notes: null,
    requiresPlan: null,
    dhType: "ללא",
    bodyType: null,
  },
];
